import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
// Admin Pages
import { AdminDashboard,AdminLogin,VerifyCode} from "./Pages/Admin/ExportsAdmin";

// Essential Pages
import { PageNotFound,LaunchingSoon } from "./Pages/EssentialPage/EssentialPage";

// User Pages
import { Courses, ForgotPassword, Home, Login, ResetPassword, Signup, InstructorPage, CoursePreview, UserPage } from "./Pages/User/ExportPages";

// Components
import { PrivacyPolicy } from "./Component/User/ExportComp";
import { InstructorApproval } from "./Component/Admin/ExportComp";

function App() {
  return (
    <>
    <BrowserRouter>
      <Routes>
        {/* Admin */}
      {/* Admin Entry */}
        {/* <Route path='/admin/login' element={<AdminLogin/>} />
        <Route path='/admin/login/verify/:id'  element={<VerifyCode/>} /> */}

       {/* Admin Page Protected */}
        {/* <Route path='/admin/dashboard' element={<AdminDashboard />} />
        <Route path='/admin/instructor/approve/:id' element={<InstructorApproval/>}/>





      {/* User */}
      {/* <Route path='/' element={<Home />} />
      <Route path='/courses' element={<Courses />} />
      <Route path='/instructor' element={<InstructorPage/>} />
      <Route path='/course/:id' element={<CoursePreview/>} />
      <Route path='/profile' element={<UserPage/>}/> */}
      

{/* 
      <Route path='/login' element={<Login/>}/>
      <Route path='/signup' element={<Signup/>}/>
      <Route path='/passwordResetRequest' element={<ForgotPassword/>}/>
      <Route path='/passwordReset/:id' element={<ResetPassword/>}/>  */}

      {/* 404 Page Not Found */}
      {/* <Route path='*' element={<PageNotFound />} /> */}
      <Route path='*' element={<LaunchingSoon />} />
      <Route path='/privacy-policy' element={<PrivacyPolicy/>}/>

      {/* User */}
      </Routes>
    </BrowserRouter>
    </>
  );
}


export default App;
